import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MediaModule } from '@spartacus/storefront';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { ShimanoImageZoomComponent } from './shimano-image-zoom.component';

@NgModule({
  imports: [CommonModule, MediaModule, NgxImageZoomModule, ShimanoImageZoomComponent],
  exports: [ShimanoImageZoomComponent],
})
export class ShimanoImageZoomModule {}
